<script setup lang="ts">
import VisitV11Page from "@/components/visit-v11/VisitV11Page.vue";

definePage({
  meta: {
    navActiveLink: "healthcare-visits",
    permissionKey: "page.healthcare.visits",
  },
});

const route = useRoute();
const visitName = computed(() => {
  const params = route.params as Record<string, string | string[] | undefined>;
  const value = params.id ?? "";

  return String(Array.isArray(value) ? value[0] : value);
});
</script>

<template>
  <VisitV11Page :visit-name="visitName" />
</template>
